import Logo from "@modules/layout/header/logo";
import Loading from "@svg/loading";



const FetchingView = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f1f2f3",
      }}
    >
      <div
        style={{
          width: "400px",
          padding: "30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
        }}
      >
        <div>
          <Logo withTitle width={200} height={120} />
          <Loading className="text-fds-brand" />
        </div>
        <p className="text-fds-primary body-lg">لطفاً منتظر بمانید...</p>
      </div>
    </div>
  );
};

export default FetchingView;
